// extracted by css-extract-rspack-plugin
export default {"constructionModal":"constructionModal-bhENKc"};